import { lazyNamed } from 'src/utils/lazyNamed';

export const CreditCardReceipts = {
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  Payments: lazyNamed(() => import('./containers/Payments'), 'Payments'),
  Payouts: lazyNamed(() => import('./containers/Payouts'), 'Payouts'),
};
